const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速播放引擎',
    desc: '自主研发播放内核，多线CDN全球加速，蓝光原画秒加载，告别缓冲等待。支持4K超清画质实时解码，观影流畅不卡顿。',
  },
  {
    icon: 'ri-hd-line',
    title: '蓝光高清画质',
    desc: '院线大片蓝光原盘压制，HDR高动态范围呈现，色彩精准细节丰富。多档画质自由切换，兼顾画质与网速。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净观影',
    desc: '全站无弹窗广告、无恶意跳转、无强制注册。影片资源严格审核，纯净观影环境，保护您的设备安全与隐私。',
  },
];

export default function Features() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-950">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
            <i className="ri-vip-crown-line text-primary-400 text-sm"></i>
            <span className="text-xs font-medium text-primary-400 whitespace-nowrap">核心优势</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            极速播放
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            三大核心技术，为您打造极致观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feat, i) => (
            <div
              key={i}
              className="group bg-background-900/60 rounded-2xl p-6 md:p-8 border border-background-800/60 hover:border-primary-500/20 transition-all duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-500/10 mb-5 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${feat.icon} text-2xl md:text-3xl text-primary-400`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-3">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}